import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrEmptyString } from '../../../../shared/utils.js';
import { Subject, Subscription, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { isNullOrUndefined } from 'util';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { CMClub, CMClubResponse } from '../../../models/cm-club-service.model';
import { DropDownItem, IntDropDownItem, SimpleResponse, UserDD } from '../../../models/generic-response.model';
import { Membership, MemCase, MemCaseItem, MemCaseListRequest, MemCaseResponse, MemContactListDropDown, MemPause, MemPauseListRequest, MemPauseResponse, REF_MemCaseConcernLevel, REF_MemCaseOrigin, REF_MemCaseReason, REF_MemCaseStatus, REF_MemFailedInspectionLevel, REF_MemProtectionPlan } from '../../../models/membership.model';
import { CMClubService } from '../../../services/cm-club.service';
import { MembershipService } from '../../../services/membership.service';
import { NotificationService } from '../../../services/notification.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';
import { UserService } from '../../../services/user.service';

@Component({
    selector: 'app-mem-case',
    templateUrl: './mem-case.component.html',
    styleUrls: ['./mem-case.component.css']
})
/** mem-case component*/
export class MemCaseComponent {

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    dataSource: MatTableDataSource<MemCaseItem>;
    displayedColumns: string[] = ['caseNumber', 'subject', 'dtOpened', 'dtClosed', 'caseReason', 'caseResolution', 'caseStatus'];
    encryptedUser: string;
    cases: MemCaseItem[];
    memCaseListRequest = {} as MemCaseListRequest;
    user: BCMCLPUser;
    clpCompanyId: number;
    siteId: number;
    sites: number[];
    users: number[];
    class4Code: any;
    curTeam: TeamCodes = <TeamCodes>{};
    clubConfig: CMClub;
    caseForm: FormGroup;
    myForm: FormGroup
    ref_MemFailedInspectionLevel_List: REF_MemFailedInspectionLevel[];
    ref_MemCaseStatus_List: REF_MemCaseStatus[];
    ref_MemProtectionPlan_List: REF_MemProtectionPlan[];
    ref_MemCaseOrigin_List: REF_MemCaseOrigin[];
    ref_MemCaseReason_List: REF_MemCaseReason[];
    ref_MemCaseConcernLevel_List: REF_MemCaseConcernLevel[];
    @Input() caseID: number;
    @Input() contactId: number = 0;
    @Input() isContact: boolean = false;
    memCase: MemCase;
    clpUsersDD: UserDD[];
    memberShip: Membership;
    memContact_dd: MemContactListDropDown[];
    @Output() isCloseButton = new EventEmitter<boolean>();
    teamSub: Subscription;
    private destroy$ = new Subject<void>();

    /** mem-case ctor */
    constructor(private localService: LocalService,
        private userService: UserService,
        private _utilityService: UtilityService,
        private clubService: CMClubService,
        private fb: FormBuilder,
        private _membershipService: MembershipService,
        private _notifyService: NotificationService,
        private _globalService: GlobalService,
        private _route: ActivatedRoute,
        private _teamOfficeService: TeamOfficeService,
        private _router: Router,
        private datePipe: DatePipe,
        private route: ActivatedRoute,) {
        this.localService.setIsContract(false);
        this.localService.setShowMenu(true);
        this.localService.setIsMembership(true);
        this.localService.setRouteName("mem-case");
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngAfterViewInit() {
        this.sites = [];

        this.encryptedUser = localStorage.getItem("token");
        this.siteId = this.route.snapshot.queryParams.siteId;
        this.sites.push(1);
        this.class4Code = this.route.snapshot.queryParams.c4Code;
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    if (this.caseID > 0) {
                        this.memCase_Get();
                    }
                    else {
                        this.caseID = this._route.snapshot.queryParams.caseID ? this._route.snapshot.queryParams.caseID : 0;
                        if (this.caseID > 0) {
                            this.memCase_Get();
                        }
                    }
                    this.users = [];
                    this.users.push(this.user.cLPUserID);
                    this.loadData();

                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    prepareCaseForm() {
        return this.fb.group({
            caseID: ['0'],
            clpCompanyID: ['0'],
            clpUserID: ['0'],
            caseNumber: [''],
            statusID: ['0'],
            concernLevelID: ['0'],
            subject: [''],
            failedInspectionLevel: ['0'],
            description: [''],
            reservationID: ['0'],
            caseResolution: [''],
            vesselPlusLocation: [''],
            vesselNo: [''],
            caseOwnerId: ['0'],
            transactionID: ['0'],
            formID: ['0'],
            transactionAmount: ['0'],
            invoiceLink: [''],
            protectionPlan: ['0'],
            incidentDate: [''],
            daysToCaseClose: ['0'],
            caseOpenAge: ['0'],
            inspectionFormID: ['0'],
            workOrderID: ['0'],
            dockhand: [''],
            deductibleApplied: ['0'],
            incidentDateTime: [''],
            incidentAmountTotal: ['0'],
            incidentType: [''],
            incidentDescription: [''],
            afterTaxAmount: ['0'],
            retailCostOfDamage: ['0'],
            jetRideDamageSavings: ['0'],
            caseOrigin: ['0'],
            caseReason: ['0'],
            memberConcernLevel: ['0'],
            internalComments: [''],
            caseReasonDescription: [''],
            userStory: [''],
            dtOpened: [''],
            dtClosed: [''],
            webEmail: [''],
            webCompany: [''],
            webName: [''],
            webPhone: [''],
            filteringAttribute: [''],
            createdBy: ['0'],
            contactId: [0]
        })
    }

    ngOnInit() {
        this.caseForm = this.prepareCaseForm();
        //this.getMembershipList();
    }

    private async authenticateR() {

        await this.localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    this.clpCompanyId = this.user?.cLPCompanyID

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    getDate(value) {
        if (value == '0001-01-01T00:00:00') {
            return '';
        }
        else
            return value;
    }

    async loadData() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null)
                this.curTeam = data
            else
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
        })
        if (this.curTeam?.teamCode > 0) {
            await this.CMClub_Get();
            await this.memContactDDget();
            await this.cLPUserGetListByTeamCode(this.user?.cLPCompanyID, this.curTeam?.teamCode);
            this.ref_MemFailedInspectionLevel_List = this.localService.refMem_GetAllResponse.ref_MemFailedInspectionLevel_List;
            this.ref_MemCaseStatus_List = this.localService.refMem_GetAllResponse.ref_MemCaseStatus_List;
            this.ref_MemProtectionPlan_List = this.localService.refMem_GetAllResponse.ref_MemProtectionPlan_List;
            this.ref_MemCaseOrigin_List = this.localService.refMem_GetAllResponse.ref_MemCaseOrigin_List;
            this.ref_MemCaseReason_List = this.localService.refMem_GetAllResponse.ref_MemCaseReason_List;
            this.ref_MemCaseConcernLevel_List = this.localService.refMem_GetAllResponse.ref_MemCaseConcernLevel_List;
        }
        //await this.getMembershipList();
    }

    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {
            await this.clubService.CMClub_Get(this.encryptedUser, this.clpCompanyId, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig
                    }

                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }
    async cLPUserGetListByTeamCode(clpCompanyId, teamCode) {
        await this.userService.cLPUserGetListByTeamCode(this.encryptedUser, clpCompanyId, teamCode ? teamCode : this.user?.cLPUserID).
            then(async (result: UserDD[]) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.clpUsersDD = response
                    this.clpUsersDD.unshift({
                        value: 0,
                        text: "--ALL--"
                    })
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memCase_Create() {
        if (!this.validateOpenCloseDate()) {
            Swal.fire({ icon: "warning", title: "", html: 'Invalid Closed Date!' });
            return;
        }
        if (this.caseForm.controls.contactId.value == 0) {
            Swal.fire({ icon: "warning", title: "", html: 'Please select contact!' });
            return;
        }
        let memCase: MemCase = <MemCase>{};
        memCase.caseID = 0;
        memCase.contactID = this.caseForm.controls.contactId.value;
        memCase.clpCompanyID = this.user?.cLPCompanyID;
        memCase.clpUserID = this.user?.cLPUserID;
        memCase.membershipIID = +this.memberShip.incrementalID;
        memCase.caseNumber = this.caseForm.controls.caseNumber.value;
        memCase.statusID = +this.caseForm.controls.statusID.value;
        memCase.concernLevelID = 0;
        memCase.subject = this.caseForm.controls.subject.value;
        memCase.failedInspectionLevel = +this.caseForm.controls.failedInspectionLevel.value;
        memCase.description = this.caseForm.controls.description.value;
        memCase.reservationID = 0;
        memCase.caseResolution = this.caseForm.controls.caseResolution.value;
        memCase.vesselPlusLocation = this.caseForm.controls.vesselPlusLocation.value;
        memCase.vesselNo = this.caseForm.controls.vesselNo.value;
        memCase.caseOwnerId = this.caseForm.controls.caseOwnerId.value;
        memCase.transactionID = 0;
        memCase.formID = 0;
        memCase.transactionAmount = +this.caseForm.controls.transactionAmount.value;
        memCase.invoiceLink = this.caseForm.controls.invoiceLink.value;
        memCase.protectionPlan = +this.caseForm.controls.protectionPlan.value;
        memCase.incidentDate = this.formatDateWithTime(this.caseForm.controls.incidentDate.value);
        memCase.daysToCaseClose = +this.caseForm.controls.daysToCaseClose.value;
        memCase.caseOpenAge = +this.caseForm.controls.caseOpenAge.value;
        memCase.inspectionFormID = 0;
        memCase.workOrderID = 0;
        memCase.dockhand = this.caseForm.controls.dockhand.value;
        memCase.deductibleApplied = false;
        memCase.incidentDateTime = this.formatDateWithTime(this.caseForm.controls.incidentDateTime.value);
        memCase.incidentAmountTotal = +this.caseForm.controls.incidentAmountTotal.value;
        memCase.incidentType = 'test';
        memCase.incidentDescription = this.caseForm.controls.incidentDescription.value;
        memCase.afterTaxAmount = +this.caseForm.controls.afterTaxAmount.value;
        memCase.retailCostOfDamage = +this.caseForm.controls.retailCostOfDamage.value;
        memCase.jetRideDamageSavings = +this.caseForm.controls.jetRideDamageSavings.value;
        memCase.caseOrigin = +this.caseForm.controls.caseOrigin.value;
        memCase.caseReason = +this.caseForm.controls.caseReason.value;
        memCase.memberConcernLevel = +this.caseForm.controls.memberConcernLevel.value;
        memCase.internalComments = this.caseForm.controls.internalComments.value;
        memCase.caseReasonDescription = this.caseForm.controls.caseReasonDescription.value;
        memCase.userStory = this.caseForm.controls.userStory.value;
        memCase.dtOpened = this.formatDateWithTime(this.caseForm.controls.dtOpened.value);
        memCase.dtClosed = this.formatDateWithTime(this.caseForm.controls.dtClosed.value);
        memCase.webEmail = this.caseForm.controls.webEmail.value;
        memCase.webCompany = this.caseForm.controls.webCompany.value;
        memCase.webName = this.caseForm.controls.webName.value;
        memCase.webPhone = 'test';
        memCase.filteringAttribute = this.caseForm.controls.filteringAttribute.value;
        memCase.createdBy = this.user?.cLPUserID;
        //memCase.dtCreated = 'test';
        //memCase.modifiedBy = 0;
        //memCase.dtModified = 'test';
        await this._membershipService.memCase_Create(this.encryptedUser, memCase).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.caseID = response?.messageInt;
                    if (response?.messageBool) {
                        this.memCase_Get();
                        this._router.navigate(['/mem-case'], { queryParams: { caseID: this.caseID } });
                        Swal.fire({ icon: "success", title: "", html: 'Successfully Created!' });
                        return;
                    }
                    else {
                        Swal.fire({ icon: "error", title: "", html: 'Some error occurred, Try again.' });
                        return;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-list.cMContractGetList", err.message, null,
                    'clpCompanyId: ' + this.clpCompanyId
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memCase_Update() {
        if (!this.validateOpenCloseDate()) {
            Swal.fire({ icon: "warning", title: "", html: 'Invalid Closed Date!' });
            return;
        }
        if (this.caseForm.controls.contactId.value == 0) {
            Swal.fire({ icon: "warning", title: "", html: 'Please select contact!' });
            return;
        }
        let memCase: MemCase = <MemCase>{};
        memCase.caseID = this.caseID;
        memCase.contactID = this.caseForm.controls.contactId.value;
        memCase.clpCompanyID = this.user?.cLPCompanyID;
        memCase.clpUserID = this.user?.cLPUserID;
        memCase.membershipIID = +this.memberShip.incrementalID ? +this.memberShip.incrementalID : this.memCase?.membershipIID;
        memCase.caseNumber = this.caseForm.controls.caseNumber.value;
        memCase.statusID = +this.caseForm.controls.statusID.value;
        memCase.concernLevelID = 0;
        memCase.subject = this.caseForm.controls.subject.value;
        memCase.failedInspectionLevel = +this.caseForm.controls.failedInspectionLevel.value;
        memCase.description = this.caseForm.controls.description.value;
        memCase.reservationID = 0;
        memCase.caseResolution = this.caseForm.controls.caseResolution.value;
        memCase.vesselPlusLocation = this.caseForm.controls.vesselPlusLocation.value;
        memCase.vesselNo = this.caseForm.controls.vesselNo.value;
        memCase.caseOwnerId = this.caseForm.controls.caseOwnerId.value;
        memCase.transactionID = 0;
        memCase.formID = 0;
        memCase.transactionAmount = +this.caseForm.controls.transactionAmount.value;
        memCase.invoiceLink = this.caseForm.controls.invoiceLink.value;
        memCase.protectionPlan = +this.caseForm.controls.protectionPlan.value;
        memCase.incidentDate = this.formatDateWithTime(this.caseForm.controls.incidentDate.value);
        memCase.daysToCaseClose = +this.caseForm.controls.daysToCaseClose.value;
        memCase.caseOpenAge = +this.caseForm.controls.caseOpenAge.value;
        memCase.inspectionFormID = 0;
        memCase.workOrderID = 0;
        memCase.dockhand = this.caseForm.controls.dockhand.value;
        memCase.deductibleApplied = false;
        memCase.incidentDateTime = this.formatDateWithTime(this.caseForm.controls.incidentDateTime.value);
        memCase.incidentAmountTotal = +this.caseForm.controls.incidentAmountTotal.value;
        memCase.incidentType = 'test';
        memCase.incidentDescription = this.caseForm.controls.incidentDescription.value;
        memCase.afterTaxAmount = +this.caseForm.controls.afterTaxAmount.value;
        memCase.retailCostOfDamage = +this.caseForm.controls.retailCostOfDamage.value;
        memCase.jetRideDamageSavings = +this.caseForm.controls.jetRideDamageSavings.value;
        memCase.caseOrigin = +this.caseForm.controls.caseOrigin.value;
        memCase.caseReason = +this.caseForm.controls.caseReason.value;
        memCase.memberConcernLevel = +this.caseForm.controls.memberConcernLevel.value;
        memCase.internalComments = this.caseForm.controls.internalComments.value;
        memCase.caseReasonDescription = this.caseForm.controls.caseReasonDescription.value;
        memCase.userStory = this.caseForm.controls.userStory.value;
        memCase.dtOpened = this.formatDateWithTime(this.caseForm.controls.dtOpened.value);
        memCase.dtClosed = this.formatDateWithTime(this.caseForm.controls.dtClosed.value);
        memCase.webEmail = this.caseForm.controls.webEmail.value;
        memCase.webCompany = this.caseForm.controls.webCompany.value;
        memCase.webName = this.caseForm.controls.webName.value;
        memCase.webPhone = 'test';
        memCase.filteringAttribute = this.caseForm.controls.filteringAttribute.value;
        memCase.createdBy = this.memCase.createdBy;
        //memCase.dtCreated = 'test';
        //memCase.modifiedBy = 0;
        //memCase.dtModified = 'test';
        await this._membershipService.memCase_Update(this.encryptedUser, memCase).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response?.messageBool) {
                        this.memCase_Get();
                        Swal.fire({ icon: "success", title: "", html: 'Successfully update!' });
                        return;
                    }
                    else {
                        Swal.fire({ icon: "error", title: "", html: 'Some error occurred, Try again.' });
                        return;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-list.cMContractGetList", err.message, null,
                    'clpCompanyId: ' + this.clpCompanyId
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    formatDateWithTime(dateString) {
        if (dateString != '' && !isNullOrUndefined(dateString)) {
            const now = new Date();

            const dt = new Date(dateString)
            const merged = new Date(
                dt.getFullYear(),
                dt.getMonth(),
                dt.getDate(),
                now.getHours(),
                now.getMinutes(),
                now.getSeconds()
            );
            return this.datePipe.transform(merged, "MM/dd/yyyy h:mm a");
        }
        else return '';
    }

    validateOpenCloseDate() {
        const strOpened = this.caseForm.controls.dtOpened.value
        const strClosed = this.caseForm.controls.dtClosed.value
        const openedDate = strOpened ? this.toDateOnly(new Date(strOpened)) : null;
        const closedDate = strClosed ? this.toDateOnly(new Date(strClosed)) : null;
        const today = this.toDateOnly(new Date());
        if (!isNullOrEmptyString(strOpened) && !isNullOrEmptyString(strClosed) && openedDate > closedDate) {
            return false;
        } else if (isNullOrEmptyString(strOpened) && !isNullOrEmptyString(strClosed) && today > closedDate) {
            return false;
        } else return true;
    }

    toDateOnly(d: Date): Date {
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }

    async memCase_Delete() {
        Swal.fire({
            title: '',
            text: "Are you sure, You wants to delete?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {
                await this._membershipService.memCase_Delete(this.encryptedUser, this.caseID).
                    then(async (result: SimpleResponse) => {
                        if (result) {
                            let response = UtilityService.clone(result);
                            if (response?.messageBool) {
                                if (this.isContact) {
                                    this.isCloseButton.emit(true);
                                } else {
                                    this._router.navigate(['/mem-case-list'])
                                }
                            }
                            else {

                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this._globalService.error("cm-contract-list.cMContractGetList", err.message, null,
                            'clpCompanyId: ' + this.clpCompanyId
                        );
                        this._utilityService.handleErrorResponse(err);
                    });
            }
        });
    }

    async memCase_Get() {
        await this._membershipService.memCase_Get(this.encryptedUser, this.caseID).
            then(async (result: MemCase) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.memCase = response;
                    this.patchCaseForm();
                    await this.membership_GetByContactID(this.memCase.contactID);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-list.cMContractGetList", err.message, null,
                    'clpCompanyId: ' + this.clpCompanyId
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    patchCaseForm() {
        this.caseForm.controls.caseID.setValue(this.memCase.caseID);
        this.caseForm.controls.caseNumber.setValue(this.memCase.caseNumber);
        this.caseForm.controls.statusID.setValue(this.memCase.statusID);
        this.caseForm.controls.subject.setValue(this.memCase.subject);
        this.caseForm.controls.failedInspectionLevel.setValue(this.memCase.failedInspectionLevel);
        this.caseForm.controls.description.setValue(this.memCase.description);
        this.caseForm.controls.reservationID.setValue(this.memCase.reservationID);
        this.caseForm.controls.caseResolution.setValue(this.memCase.caseResolution);
        this.caseForm.controls.vesselPlusLocation.setValue(this.memCase.vesselPlusLocation);
        this.caseForm.controls.vesselNo.setValue(this.memCase.vesselNo);
        this.caseForm.controls.caseOwnerId.setValue(this.memCase.caseOwnerId);
        this.caseForm.controls.transactionID.setValue(this.memCase.transactionID);
        this.caseForm.controls.formID.setValue(this.memCase.formID);
        this.caseForm.controls.transactionAmount.setValue(this.memCase.transactionAmount);
        this.caseForm.controls.invoiceLink.setValue(this.memCase.invoiceLink);
        this.caseForm.controls.protectionPlan.setValue(this.memCase.protectionPlan);
        this.caseForm.controls.incidentDate.setValue(this.memCase.incidentDate);
        this.caseForm.controls.daysToCaseClose.setValue(this.memCase.daysToCaseClose);
        this.caseForm.controls.caseOpenAge.setValue(this.memCase.caseOpenAge);
        this.caseForm.controls.inspectionFormID.setValue(this.memCase.inspectionFormID);
        this.caseForm.controls.workOrderID.setValue(this.memCase.workOrderID);
        this.caseForm.controls.dockhand.setValue(this.memCase.dockhand);
        this.caseForm.controls.deductibleApplied.setValue(this.memCase.deductibleApplied);
        this.caseForm.controls.incidentDateTime.setValue(this.memCase.incidentDateTime);
        this.caseForm.controls.incidentAmountTotal.setValue(this.memCase.incidentAmountTotal);
        this.caseForm.controls.incidentType.setValue(this.memCase.incidentType);
        this.caseForm.controls.incidentDescription.setValue(this.memCase.incidentDescription);
        this.caseForm.controls.afterTaxAmount.setValue(this.memCase.afterTaxAmount);
        this.caseForm.controls.retailCostOfDamage.setValue(this.memCase.retailCostOfDamage);
        this.caseForm.controls.jetRideDamageSavings.setValue(this.memCase.jetRideDamageSavings);
        this.caseForm.controls.caseOrigin.setValue(this.memCase.caseOrigin);
        this.caseForm.controls.caseReason.setValue(this.memCase.caseReason);
        this.caseForm.controls.memberConcernLevel.setValue(this.memCase.memberConcernLevel);
        this.caseForm.controls.internalComments.setValue(this.memCase.internalComments);
        this.caseForm.controls.caseReasonDescription.setValue(this.memCase.caseReasonDescription);
        this.caseForm.controls.userStory.setValue(this.memCase.userStory);
        this.caseForm.controls.dtOpened.setValue(this.memCase.dtOpened);
        this.caseForm.controls.dtClosed.setValue(this.memCase.dtClosed);
        this.caseForm.controls.webEmail.setValue(this.memCase.webEmail);
        this.caseForm.controls.webCompany.setValue(this.memCase.webCompany);
        this.caseForm.controls.webName.setValue(this.memCase.webName);
        this.caseForm.controls.webPhone.setValue(this.memCase.webPhone);
        this.caseForm.controls.filteringAttribute.setValue(this.memCase.filteringAttribute);
        this.caseForm.controls.createdBy.setValue(this.memCase.createdBy);
        this.caseForm.controls.contactId.setValue(this.memCase.contactID)
    }

    selectRow(row: any): void {
        if (row) {
            //let url = "cm-contract/" + row?.contactID + '?r=' + this.encryptedUser
            //window.open(url, '_blank')
            //this.selectedRowIndex = row.sn;
        }
    }

    formatDate(dateString) {
        if (dateString != '' && !isNullOrUndefined(dateString)) {
            const date = new Date(dateString);
            //const formattedDate = `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
            const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            return formattedDate;
        }
        else return '';
    }

    async memContactDDget() {
        await this._membershipService.memContact_CMMember_GetList_DD(this.encryptedUser, this.user?.cLPCompanyID, this.user?.cLPUserID, this.clubConfig?.clubId)
            .then(async (result: MemContactListDropDown[]) => {
                if (result) {
                    this.memContact_dd = UtilityService.clone(result);

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-pause.memContactDDget", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }


    async onChangeMemContact() {
        await this.membership_GetByContactID(+this.caseForm.controls.contactId.value);
    }

    async membership_GetByContactID(contactID) {
        await this._membershipService.membership_GetByContactID(this.encryptedUser, contactID)
            .then(async (result: Membership) => {
                if (result) {
                    this.memberShip = <Membership>{};
                    this.memberShip = UtilityService.clone(result);
                    if (isNullOrUndefined(this.memberShip)) {
                        Swal.fire({ icon: "error", title: "", html: 'The Contact is Not Subcribe!' });
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-pause.membership_GetByContactID", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }
}
